import React from 'react';
import { credentialFields } from '../../data/initiatives';

/** Illustrative structure of the proposed portable credential. */
export function CognocracyCredential() {
  return <div data-id="element-227" data-mp="2bm8n632xhny3">
      <figure className="bg-white border border-line rounded-lg overflow-hidden" data-id="element-228" data-mp="2blpdf9nfm5v5">
        <figcaption className="flex flex-wrap items-center justify-between gap-2 px-6 py-4 border-b border-line bg-surface-muted" data-id="element-229" data-mp="26n5rh98u8u2s">
          <span className="font-heading font-semibold text-ink-dark" data-id="element-230" data-mp="34b63i0nkxao7">Potential credential fields</span>
          <span className="text-xs font-medium text-ink-muted" data-id="element-231" data-mp="2zcusvnpgmw4x">Illustrative structure · not an active credential</span>
        </figcaption>
        <dl className="divide-y divide-line" data-id="element-232" data-mp="2uet9t2s1awtg">
          {credentialFields.map(field => <div key={field} className="grid grid-cols-1 sm:grid-cols-[minmax(0,15rem)_1fr] gap-2 sm:gap-6 px-6 py-4 items-center" data-id="element-233" data-mp="2qavcmxm9rw31">
              <dt className="text-sm font-semibold text-ink-dark" data-id="element-234" data-mp="1ew7ys56h19hb">{field}</dt>
              <dd aria-hidden="true" className="h-2.5 rounded-full bg-surface-muted border border-dashed border-line" data-id="element-235" data-mp="1ey2ijg60avjt" />
            </div>)}
        </dl>
      </figure>
      <p className="mt-6 border-l-2 border-teal pl-4 text-ink-dark leading-relaxed" data-id="element-236" data-mp="1gqouwf7z9gmk">
        Credential sharing would need clear privacy controls and defined limits on disclosure and use.
      </p>
    </div>;
}